import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { Icon } from '@platform/ui';
import type { IAdvancedButtonProps } from './IAdvancedButtonProps';

/**
 * Кнопка «Розширені фільтри» (прототип v4): 30px, лійка; із застосованими умовами — «Розширені фільтри · N» з акцентними рамкою, текстом
 * і тлом. aria-pressed — чи відкрита панель умов; доступна назва — видимий підпис (з кількістю).
 */
export function AdvancedButton({ count, open, onToggle }: IAdvancedButtonProps) {
  const { t } = useTranslation();
  return (
    <button type="button" className={cx('lv-fbtn', count > 0 && 'is-on')} aria-pressed={open} title={t('listbar.advanced')} onClick={onToggle}>
      <Icon name="filter" size={14} />
      {count > 0 ? t('listbar.advancedCount', { count }) : t('listbar.advanced')}
    </button>
  );
}
